// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cell-emoji{font-size:30px}.tag-category{background-color:#2a2a2f;border-radius:40px;color:#fff;display:inline-block;font-size:12px;font-weight:700;padding:4px 12px;text-transform:uppercase}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
